var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"terms-container"},[_c('div',{staticClass:"terms",domProps:{"innerHTML":_vm._s(_vm.legalCopy)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }